import * as Yup from "yup";
import dayjs from "dayjs";
// Validation schema for the form
export const validationSchema = Yup.object({
  tipoServicio: Yup.string().required("Debe seleccionar un tipo de servicio"),
  fechaEmision: Yup.date()
    .nullable()
    .required("La fecha es obligatoria")
    .typeError("Debe ser una fecha válida"),
  // fechaVencimiento: Yup.date()
  //   .nullable()
  //   .required("La fecha es obligatoria")
  //   .typeError("Debe ser una fecha válida"),
  fechaPago: Yup.date()
    .nullable()
    .required("La fecha es obligatoria")
    .typeError("Debe ser una fecha válida")
    .min(dayjs().startOf("day"), "La fecha de vencimiento no puede ser menor a la fecha de hoy"),
  // tipoMoneda: Yup.string().required("La moneda es obligatoria"),
  anio: Yup.string().required("Año es obligatorio"),
  mes: Yup.string().required("Mes es obligatorio"),
  ingresoServicio: Yup.string().required("El ingreso del servicio es obligatorio"),
  detalleIngreso: Yup.mixed()
    .test("fileType", "Solo se aceptan archivos PDF", (files) => {
      if (!files || files.length === 0) return false; // No files uploaded
      return files.every((file) => file.type === "application/pdf");
    })
    .required("Debe agregar la documentación de soporte"),
});

export const validationSchemaDatosPersonales = Yup.object({
  identidad: Yup.string().required("La identidad es obligatorio"),
  rtn: Yup.string().required("El RTN es obligatorio"),
  telefono: Yup.string()
    .matches(/^[0-9]+$/, "Solo números")
    .required("El teléfono es obligatorio"),
  correo: Yup.string().email("Debe ser un correo válido").required("El correo es obligatorio"),
  direccion: Yup.string().required("La dirección es obligatoria"),
});

export const validationSchemaContactos = Yup.object({
  nombreContacto: Yup.string().required("El nombre es obligatorio"),
  cargo: Yup.string().required("El cargo es obligatorio"),
  telefonoContacto: Yup.string()
    .matches(/^[0-9]+$/, "Solo números")
    .required("El teléfono es obligatorio"),
  emailContacto: Yup.string().email("Debe ser un correo válido").required("El correo es obligatorio"),
  direccionContacto: Yup.string().required("La dirección es obligatoria"),
  identidadContacto: Yup.string().required("La identidad es obligatoria"),
});
